import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

export const SEO_TITLE_MAX = 60;
export const SEO_DESC_MAX = 160;

const CharCounter = ({ value, max }) => {
  const length = value?.length ?? 0;
  const isOver = length > max;

  return (
    <small className={`d-block mt-1 text-end ${isOver ? "text-danger" : "text-muted"}`}>
      {length}/{max}
    </small>
  );
};

export const SeoMetaFields = ({
  metaTitle,
  metaDescription,
  onMetaTitleChange,
  onMetaDescriptionChange,
  urlPreview,
  titleLabel = "Meta Title",
  descriptionLabel = "Meta Description",
}) => (
  <>
    {urlPreview ? (
      <FormGroup>
        <Label>Preview URL</Label>
        <Input value={urlPreview} readOnly />
      </FormGroup>
    ) : null}
    <FormGroup>
      <Label>{titleLabel}</Label>
      <Input
        name="metaTitle"
        value={metaTitle ?? ""}
        onChange={onMetaTitleChange}
        placeholder="Enter SEO title (max 60 characters)"
        maxLength={SEO_TITLE_MAX + 20}
      />
      <CharCounter value={metaTitle} max={SEO_TITLE_MAX} />
    </FormGroup>
    <FormGroup>
      <Label>{descriptionLabel}</Label>
      <Input
        name="metaDescription"
        type="textarea"
        rows={4}
        value={metaDescription ?? ""}
        onChange={onMetaDescriptionChange}
        placeholder="Enter SEO description (max 160 characters)"
        maxLength={SEO_DESC_MAX + 40}
      />
      <CharCounter value={metaDescription} max={SEO_DESC_MAX} />
    </FormGroup>
  </>
);
